  <div class="container-fluid">

    <div class="d-flex justify-content-end">
        <button v-if="user_role === 'System Admin' && 'Trust Administrator'"
          @click.stop
          @click="open_verification_modal" 
          class=" btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark"
          >
          Auto Verify
        </button>
    </div>



    <!-- Verification Results Component For Admin and Client to view results -->
     <div class="border table-border-color mt-3 rounded-lg px-2">
      <AutoVerificationResults
      :application_id="application_id"
      :entity_profile_id="entity_profile_id"
      :auto_fetch="true"
    />
     </div>
    

     <!-- Verification Services Modal Component -->
    <AutoVerificationServices
      ref="verification_modal"
      :is-verifying="is_verifying"
      :entity-data="current_entity"
      @start-verification="handle_verification_start"
      @error="handle_error"
    />
  </div>